import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {CommentBottomArea} from './CommentBottomArea';
import {CommentProps} from './CommentProps.interface';
import {CommentTopArea} from './CommentTopArea';

export function Comment({
  onlyText,
  isBlockedByUser,
  isTemp,
  isReply,
  isBestComment,
  isMyComment,
  isSpoiler,
  nickname = '',
  registrationDate,
  emoticon,
  comment: _comment = '',
  seriesText,
  likeCount,
  replyCount,
  isLikeActive,
  isReplyActive,
  hasMyReplyComment,
  onClickLike,
  onClickMore,
  onClickReply,
  onClickSpoilerVisible,

  className,
}: CommentProps) {
  const comment = emoticon ? _comment?.replace('(이모티콘)', '') : _comment;

  if (onlyText && onlyText !== '') {
    return (
      <div className={twMerge('flex justify-center', className)}>
        <Text className="font-small2 text-theme-solid-40">{onlyText}</Text>
      </div>
    );
  }
  return (
    <div className={twMerge('flex flex-col', className)}>
      <CommentTopArea
        registrationDate={registrationDate}
        nickname={nickname}
        isBestComment={isBestComment}
        isBlockedByUser={isBlockedByUser}
        onClickMore={onClickMore}
      />
      <CommentBottomArea
        onlyText={
          isBlockedByUser
            ? t(isReply ? 'comment_I_blocked_2' : 'comment_I_blocked_1')
            : ''
        }
        isMyComment={isMyComment}
        isSpoiler={isSpoiler}
        emoticon={emoticon}
        comment={comment}
        seriesText={seriesText}
        likeCount={likeCount}
        replyCount={replyCount}
        hasMyReplyComment={hasMyReplyComment}
        isLikeActive={isLikeActive}
        isReplyActive={isReplyActive}
        shouldShowInfringeRight={isTemp && isMyComment}
        shouldHideLikeButton={isBlockedByUser || isTemp}
        shouldHideReplyButton={isBlockedByUser || isTemp || isReply}
        onClickMore={onClickMore}
        onClickLike={onClickLike}
        onClickReply={onClickReply}
        onClickSpoilerVisible={onClickSpoilerVisible}
        className="mt-10pxr"
      />
    </div>
  );
}
